import { showInterstitial } from "utils/utils";
import JoinTournament from "./join";
import RoundStatus from "./status";
import { IonButton } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useGame } from "context/gameContext";
import { useIonRouter } from "@ionic/react";
import { Md2Loading } from "react-icons-ng/md2";
import { useState } from "react";

const CardFooter = ({ leagueData, userRoundData, invited, messageId }) => {
  const { t } = useTranslation();
  const {
    state: { premium, userGameData, settings },
  } = useGame();
  const router = useIonRouter();

  const [isLoading, setIsLoading] = useState(false);

  const callOpenLeague = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    try {
      if (!premium && settings?.adsOnOpenLeague) {
        await showInterstitial();
      }
      router.push("/tabs/tournaments/" + leagueData.id, "forward", "push");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  };

  return (
    <div className="flex w-full justify-between pb-2 px-2">
      <div className="flex w-full flex-col mr-4 justify-end">
        {userRoundData?.gameOver ? (
          <div className="flex font-ultralight text-xs text-white bg-red-500 w-fit p-2 py-1 rounded-md">
            {t("common.game_over")}
          </div>
        ) : leagueData?.settled ? (
          <div className="flex font-ultralight text-xs text-black bg-white w-fit p-2 py-1 rounded-md">
            {t("common.league_ended")}
          </div>
        ) : (
          !invited && (
            <RoundStatus
              leagueData={leagueData}
              userRoundData={userRoundData}
            />
          )
        )}
      </div>

      {userRoundData ? (
        <IonButton
          mode="ios"
          fill="outline"
          color="light"
          disabled={isLoading}
          onClick={(e) => callOpenLeague(e)}
          /*           routerDirection="forward"
          routerLink={"/tabs/tournaments/" + leagueData.id} */
          className="m-0 h-8 customButtonNew"
        >
          {!isLoading ? (
            t("lobby.card.open")
          ) : (
            <Md2Loading className="h-6 w-6 animate-spin" />
          )}
        </IonButton>
      ) : (
        <JoinTournament
          item={leagueData}
          invited={invited}
          messageId={messageId}
        />
      )}
    </div>
  );
};

export default CardFooter;
